import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Attachment = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Attachment",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        d="M11 22a2.9 2.9 0 0 1-3-3V6a4 4 0 1 1 8 0v10h-1V6a3 3 0 1 0-6 0v13a2 2 0 1 0 4 0V8a1 1 0 1 0-2 0v8h-1V8a2 2 0 0 1 4 0v11a2.9 2.9 0 0 1-3 3"
      ></path>
    </svg>
  );
};

